.sidebar {
  position: fixed;
  right: 4px;
  top: 30%;
  left: auto;
  bottom: auto;
  display: grid;
  grid-template-columns: auto auto;
  gap: 0;
  z-index: 3000;
  padding: 0;
  margin: 0;
  background: transparent;

  &.active {
    gap: 20px;

    .flyout {
      width: 100%;
      height: fit-content;
    }
  }

  p, h1, h2, h3, h4, span, a, hr {
    color: var(--color-darker-grey);
  }

  a {
    text-decoration: none;
  }

  li {
    list-style: none;

    a {
      display: block;
    }
  }

  .sidebar-buttons {
    display: block;
    width: 100%;
    padding: 0;
    margin: 0;
    z-index: 2000;

    > li {
      flex: 1 0 auto;
      display: flex;
      justify-content: end;
      color: var(--color-white);
      background: transparent;
      position: relative;

      &:first-child {
        display: none;
      }

      &:nth-child(2) {
        zoom: 1.2;
      }
    }

    .sidebar-button {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      text-align: center;
      position: relative;
      @include text-bold;
      margin-bottom: 5px;
      width: 22px;
      max-width: 22px;
      height: 22px;
      border-radius: 5px;
      padding: 10px;
      background-color: var(--font-color-main);
      color: var(--color-white);
      font-size: var(--font-size-xxs);
      gap: 0;
      -moz-transition: max-width .5s ease-in-out;
      -webkit-transition: max-width .5s ease-in-out;
      transition: max-width .5s ease-in-out;

      .icon {
        display: block;
        font-size: var(--font-size-icon-m);
        color: var(--color-white);
      }

      .i-star {
        letter-spacing: unset;
      }

      .button-text {
        width: 0;
        overflow: hidden;
      }

      &:hover, &.open {
        gap: 10px;
        width: auto;
        max-width: 200px;

        .button-text {
          width: auto;
        }
      }

      &:hover {
        .icon-rotate {
          animation: rotation infinite 3s linear;
          transform-origin: center center;
        }

        @keyframes rotation {
          from {
            transform: rotate(0deg);
          }

          to {
            transform: rotate(360deg);
          }
        }

        .icon-bounce {
          animation: bounce infinite 2s ease-in-out;
          transform-origin: center center;
        }

        @keyframes bounce {
          0%, 16%, 32%, 100% {
            transform: translateX(0);
          }
          8%, 24% {
            transform: translateX(5px);
          }
        }
      }

      &.green {
        background-color: var(--color-green);
      }

      &.red {
        background-color: var(--color-red);
      }

      &.grey {
        background-color: var(--font-color-main);
      }
    }
  }

  .flyout {
    background-color: var(--color-grey-blue);
    z-index: 1000;
    padding-bottom: 10px;
    font-weight: 700;
    text-align: center;
    border-radius: 5px;
    box-shadow: var(--color-transparent-black-50) 0 2px 4px;
    transform: scale(0);
    -moz-transition: -moz-transform .5s ease-in-out;
    -webkit-transition: -webkit-transform .5s ease-in-out;
    transition: transform .5s ease-in-out;
    transform-origin: top right;
    transition-delay: 0.1s;
    position: relative;
    top: 0;
    bottom: 0;
    width: 0;
    height: 0;
    margin: auto 0;
    max-height: calc(100vh - 20px);
    overflow-y: hidden;

    &.open {
      transform: scale(1);
    }

    &.scrollable {
      overflow-y: scroll;
      -ms-overflow-y: scroll;
    }

    > div {
      padding-left: 10px;
      padding-right: 10px;

      &:first-of-type {
        border-radius: 5px 5px 0 0;
        height: 44px;
        margin-bottom: 10px;
        padding: 10px 64px 10px 20px;

        h2, h3 {
          margin: 0;
          text-align: left;
          line-height: 1.3;
        }

        h2 {
          @include text-bold();
          color: var(--color-light-grey);
        }

        h3 {
          color: var(--color-grey);
        }
      }
    }

    .flyout-header {
      background-color: var(--color-darker-grey);
    }

    .content {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
      width: 600px;

      img {
        width: 100%;
        height: auto;
        margin-bottom: 10px;
      }

      > div {
        padding: 10px;
        border-radius: 5px;

        &:hover {
          background-color: var(--color-dark-grey);

          .content-inner p {
            color: var(--color-white);
          }
        }
      }

      a, span {
        display: unset;
      }

      .content-inner {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;

        p {
          margin-top: auto;
          margin-bottom: 5px;
          width: 100%;
          text-align: left;
        }

        .h5 {
          @include text-bold();
          @include h5();
        }
      }
    }

    .contact {
      display: flex;
      flex-direction: row;
      gap: 20px;

      > * {
        flex-grow: 1;
      }
    }

    .text {
      @include text-bold();
      @include h5();

      p {
        @include text-bold();
      }
    }

    @include card-button;

    .card-button-wrapper {
      top: 10px;
      right: 10px;

      .card-button {
        transform: rotate(45deg);
        background-color: var(--color-light-grey);

        .card-icon {
          fill: var(--color-darker-grey);
        }
      }
    }

    &.cols-1 {
      .content {
        grid-template-columns: 1fr;
        width: 300px;
      }

      .contact {
        flex-direction: column;
        gap: 5px;
      }
    }
  }

  .sidebar-button-container {
    grid-column: 2;
    position: relative;
    top: 0;
    bottom: 0;
    /*margin: auto 0;*/
  }
}

@include media-max-width($breakpoint-m) {
  .sidebar {
    display: flex;
    bottom: 0;
    left: 0;
    right: 0;
    top: auto;

    .flyout {
      position: absolute;
      top: unset;
      bottom: 50px;
      margin: auto 0;
      transform: translateY(100%);
      transform-origin: bottom center;
      border-radius: 5px 5px 0 0;

      &.open {
        transform: translateY(0);
      }

      &.cols-1 {
        .content {
          width: unset;
          grid-template-columns: 1fr 3fr 1fr;

          > div {
            grid-column: 2;
          }
        }
      }

      .content {
        width: unset;
      }

      .contact {
        flex-direction: column;
        gap: 5px;
      }
    }

    .sidebar-button-container {
      width: 100%;
      z-index: 2000;
      height: 50px;
      max-height: 350px;
      overflow: hidden;
      bottom: 0;
      -moz-transition: height .6s ease-in-out;
      -webkit-transition: height .6s ease-in-out;
      transition: height .6s ease-in-out;

      &.open {
        height: 350px;

        .sidebar-buttons {
          > li:first-child {
            .icon {
              transform: rotate(180deg);
            }
          }
        }
      }
    }

    .sidebar-buttons {
      position: absolute;
      bottom: 0;
      right: 0;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1px;
      background-color: var(--font-color-main);

      > li {
        display: block;
        grid-column: 1/span 2;
        grid-row: auto;

        &:first-child {
          display: block;
          grid-column: 1;
          grid-row: 5;

          .icon {
            -moz-transition: -moz-transform .4s ease-in-out;
            -webkit-transition: -webkit-transform .4s ease-in-out;
            transition: transform .4s ease-in-out;
          }

          .sidebar-button {
            background-color: var(--font-color-main);
            justify-content: left;
            padding-left: 20px;
          }
        }

        &:nth-child(2) {
          grid-column: 2;
          grid-row: 5;
          zoom: unset;

          .sidebar-button {
            height: 22px;
            margin: 6px;
            border-radius: 4px;
            width: auto;
            max-width: unset;
          }
        }

        &:nth-child(n + 3) {
          .sidebar-button {
            background-color: var(--color-grey);
            justify-content: left;
            padding-left: 20px;
          }
        }
      }

      .sidebar-button {
        font-size: var(--font-size-main-text);
        margin: 0;
        height: 38px;
        border-radius: 0;
        gap: 10px;
        width: auto;
        max-width: unset;
        padding: 6px;

        &:hover {
          max-width: unset;
        }

        .button-text {
          width: auto;
          line-height: 1.6;
          height: 22px;
        }
      }
    }
  }
}
